import React, {useMemo} from "react";
import objectPath from "object-path";
import {useHtmlClassService} from "../../_core/MetronicLayout";
import {Topbar} from "./Topbar";
import {HeaderMenuWrapper} from "./header-menu/HeaderMenuWrapper";
import {AnimateLoading} from "../../../_partials/controls";
import {Link} from "react-router-dom";
import {toAbsoluteUrl} from "../../../_helpers";

export function Header({sinUser}) {
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      headerClasses: uiService.getClasses("header", true),
      headerAttributes: uiService.getAttributes("header"),
      headerContainerClasses: uiService.getClasses("header_container", true),
      headerSelfTheme: objectPath.get(uiService.config, "header.self.theme"),
      menuHeaderDisplay: objectPath.get(
        uiService.config,
        "header.menu.self.display"
      )
    };
  }, [uiService]);

  const getHeaderLogo = () => {
    let result = "logo-light.png";
    if (layoutProps.headerSelfTheme && layoutProps.headerSelfTheme !== "dark") {
        result = "logo-dark.png";
    }
    //Agrego para no romper el template pero que se vea el logo
    result = "MEC-EscudoCorrientes.svg";
    return toAbsoluteUrl(`/media/logos/${result}`);
  };

  return (
    <>
      {/*begin::Header*/}
      <div
        className={`header ${layoutProps.headerClasses}`}
        id="kt_header"
        {...layoutProps.headerAttributes}
      >
        {/*begin::Container*/}
        <div className={` ${layoutProps.headerContainerClasses} d-flex align-items-stretch justify-content-between`}>
          <AnimateLoading />
          {/*begin::Header Menu Wrapper*/}
          {layoutProps.menuHeaderDisplay && <HeaderMenuWrapper />}
          {/* {!layoutProps.menuHeaderDisplay && <div />} */}
          {/*end::Header Menu Wrapper*/}

          {/* Agrego el logo en el HEADER  */}
          <div className="header-menu-wrapper header-menu-wrapper-left" id="kt_header_menu_wrapper">
            {/*begin::Header Logo*/}
            <div className="header-logo">
                <Link to="/">
                    <img alt="logo" src={getHeaderLogo()} style={{ width: 180 }} />
                </Link>
            </div>
            {/*end::Header Logo*/}
          </div>

          {/*begin::Topbar*/}
          {!(!!sinUser) && (
            <Topbar />
          )}
          {/*end::Topbar*/}
        </div>
        {/*end::Container*/}
      </div>
      {/*end::Header*/}
    </>
  );
}
